import { Component, EventEmitter, Input, OnChanges, Output, ChangeDetectionStrategy } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { CalendarMaxDate } from '@lla-platform/core/core-data-access'
import { FullScreenModalConfig, MobileMaxWidth } from '@lla-platform/core/core-util'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'
import moment from 'moment'
import {
  DatePickerDialogComponent,
  DatePickerDialogData
} from '../date-picker-dialog/date-picker-dialog.component'

@UntilDestroy()
@Component({
  selector: 'lla-date-picker-filter',
  templateUrl: './date-picker-filter.component.html',
  styleUrls: ['./date-picker-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class DatePickerFilterComponent implements OnChanges {
  @Input() value?: Date | string
  @Input() maxDate: CalendarMaxDate = 'Today'
  @Input() minDate?: string
  @Input() label = 'Select date'
  @Input() extraClasses = ''

  @Output() valueChanged = new EventEmitter<Date>()

  selectedValue?: Date | string
  formattedDate = ''
  menuIsOpen = false

  window = window
  mobileMaxWidth = MobileMaxWidth

  constructor(private dialogService: MatDialog) {}

  ngOnChanges(): void {
    this.setSelectedDate()
  }

  setSelectedDate() {
    this.selectedValue = this.value
    this.formattedDate = this.value
      ? moment(this.value).utc().format('MMM D, YYYY')
      : ''
  }

  onMenuOpened() {
    this.menuIsOpen = true
  }

  onValueChanged(date: Date) {
    this.valueChanged.emit(date)
  }

  openDatePickerModal() {
    const data: DatePickerDialogData = {
      selectedValue: this.selectedValue,
      maxDate: this.maxDate,
      minDate: this.minDate,
      label: this.label
    }

    this.dialogService
      .open(DatePickerDialogComponent, {
        ...FullScreenModalConfig,
        data
      })
      .afterClosed()
      .pipe(untilDestroyed(this))
      .subscribe((res: Date) => {
        if (!res) {
          return
        }
        this.valueChanged.emit(res)
      })
  }
}
